import {CbList} from './IEventListener';

/**
 * Класс для прослушивания и уведомления о событиях
 */
class EventListener<T extends Record<keyof T, (...event: any[]) => any>> {
  private _cbList: CbList<T> = {}

  /**
   * Добавляет слушателя события
   * @param type - имя события
   * @param listener - функция, вызываемая при возникновении события `type`
   */
  addEventListener<K extends keyof T>(
    type: K,
    listener: T[K]
  ) {
    if (!this._cbList[type]) {
      this._cbList[type] = []
    }
    this._cbList[type]!.push(listener)
  }

  /**
   * Удаляет слушателя события
   * @param type - имя события
   * @param listener - функция, вызываемая при возникновении события `type`.
   *
   * Если `listener === undefined`, то удаляются все слушатели этого события
   */
  removeEventListener<K extends keyof T>(
    type: K,
    listener?: T[K]
  ) {
    if (!listener) {
      this._cbList[type] = []
      return
    }
    const listeners = this._cbList[type]
    if (!listeners) {
      return;
    }
    const index = listeners.findIndex(l => l === listener)
    if (~index) {
      listeners.splice(index, 1)
    }
  }

  /**
   * Вызывает событие
   * @param type - имя события
   * @param opts - опции, передающиеся слушателю
   */
  emit<K extends keyof T>(type: K, ...opts: Parameters<T[K]>) {
    const events = [...this._cbList[type] || []]
    events?.forEach(l => {
      try {
        l(...opts)
      } catch (e) {
        console.error(e) // eslint-disable-line no-console
      }
    })
  }
}

export default EventListener
